import { render, staticRenderFns } from "./ReceiptSend.vue?vue&type=template&id=0046c22d&scoped=true&"
import script from "./ReceiptSend.vue?vue&type=script&lang=js&"
export * from "./ReceiptSend.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptSend.vue?vue&type=style&index=0&id=0046c22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046c22d",
  null
  
)

export default component.exports